































































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { getList, getListCountyMessage } from '../api';
import { Icon, List, Lazyload, Dialog, Toast, Popup } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast)
  .use(Popup)
  .use(Icon);
@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  search = '';
  list: any[] = [];
  objCounty: any = {};
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  countyId: any = this.$route.query.countyId;
  placeholder: any = '请输入关键字';
  showPop: boolean = false;

  onLoad() {
    getList(this.page, this.countyId, this.search).then((res: any) => {
      this.endListData(res);
    });
    getListCountyMessage(this.countyId).then((countyMes: any) => {
      this.objCounty = countyMes.data;
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  userInputChange(text: string) {
    this.search = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  goDetail(id: any, enable: any ) {
    this.$router.push(`homeDetail?id=${id}`);
  }
  goRank(id: any) {
    this.$router.push(`homerank?countyId=${id}`);
  }
  showPopup() {
    this.showPop = true;
  }
}
